import {
  PRIMARY_STACK_CLASS_NAME,
  ICON_STACK_CLASS_NAME,
  SUCCESS_STACK_CLASS_NAME,
  WARNING_STACK_CLASS_NAME,
  SECONDARY_STACK_CLASS_NAME,
  INFORMATION_STACK_CLASS_NAME,
  UPLOAD_DOCUMENT_STACK_CLASS_NAME,
  DASHED_OUTLINE_STACK_CLASS_NAME,
  HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME,
  COLORED_BORDERED_STACK_CLASS_NAME,
  DASHED_WARNING_STACK_CLASS_NAME,
  DASHED_GRAY_STACK_CLASS_NAME,
  PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME,
  SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME,
  PENDING_STACK_CLASS_NAME,
  BORDERED_BACKGROUND_STACK_CLASS_NAME,
  SELECTABLE_CARD_STACK_CLASS_NAME,
  SELECTABLE_CARD_STACK_ACTIVE_CLASS_NAME,
  SELECTABLE_CARD_LINK_STACK_CLASS_NAME,
  VERTICAL_SCROLL_STACK_CLASS_NAME,
  PRIMARY_VERTICAL_DIVIDERS_STACK_CLASS_NAME,
} from '../../constants/stack';

const primaryStack = ({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
});

const iconStack = ({ theme }) => ({
  color: theme.palette.primary.main,
});

const informationStack = ({ theme }) => ({
  backgroundColor: theme.palette.primary.A100,
  '& .MuiTypography-root': {
    color: theme.palette.primary.A800,
  },
});

const successStack = ({ theme }) => ({
  backgroundColor: theme.palette.success.A200,
  color: theme.palette.success.A800,
  '& .MuiTypography-root': {
    color: theme.palette.success.A800,
  },
  '& .MuiIconButton-root': {
    color: theme.palette.success.A800,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.success.A800,
  },
});

const warningStack = ({ theme }) => ({
  backgroundColor: theme.palette.secondary.A100,
  color: theme.palette.secondary.A800,
  '& .MuiTypography-root': {
    color: theme.palette.secondary.A800,
  },
  '& .MuiIconButton-root': {
    color: theme.palette.secondary.A800,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.secondary.A800,
  },
});

const dashedWarningStack = ({ theme }) => ({
  border: '2px dashed',
  borderColor: theme.palette.warning.A600,
  backgroundColor: theme.palette.warning.A100,
  borderRadius: 12,
  padding: 16,
});

const dashedGrayStack = ({ theme }) => ({
  border: '2px dashed',
  borderColor: theme.palette.gray.A300,
  borderRadius: 8,
  padding: 4,
  backgroundColor: theme.palette.gray.A100,
});

const secondaryStack = ({ theme }) => ({
  backgroundColor: theme.palette.primary.A100,
});

const uploadDocumentStack = ({ theme }) => ({
  border: '1px dashed',
  borderColor: theme.palette.gray.A300,
  borderRadius: 8,

});

export const highlightedUploadDocumentStack = ({ theme, borderColor }) => ({
  ...uploadDocumentStack({ theme }),
  border: '2px dashed',
  borderColor,
  borderRadius: 6,
  backgroundColor: theme.palette.common.white,
});

const dashedOutlineStack = ({ theme }) => ({
  paddingLeft: 16,
  paddingRight: 16,
  height: 48,
  boxSizing: 'border-box',
  cursor: 'pointer',
  border: '2px dashed',
  borderColor: theme.palette.gray.A300,
  borderRadius: 6,
  gap: 12,
  backgroundColor: theme.palette.common.white,
});

export const confirmationIconStack = () => ({
});

export const successConfirmationIconStack = () => ({
});

const coloredBorderedStack = ({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.primary.main,
});

const pendingStack = ({ theme }) => ({
  backgroundColor: theme.palette.warning.A100,
  color: theme.palette.warning.A700,
  '& .MuiTypography-root': {
    color: theme.palette.warning.A700,
  },
  '& .MuiIconButton-root': {
    color: theme.palette.warning.A700,
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.warning.A700,
  },
});

const borderedBackgroundStack = () => ({
});

export const selectableCardStackActive = ({ theme }) => ({
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.A100,
});

export const selectableCardStack = ({ theme }) => ({
  position: 'relative',
  padding: 12,
  borderRadius: 8,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.gray.A100,
  backgroundColor: theme.palette.gray.A100,
  textAlign: 'left',
  transition: 'border-color 0.15s ease, background-color 0.15s ease',
  [`&.${SELECTABLE_CARD_STACK_ACTIVE_CLASS_NAME}`]: selectableCardStackActive({ theme }),
});

export const selectableCardLinkStack = ({ theme }) => ({
  ...selectableCardStack({ theme }),
  flex: 1,
  textDecoration: 'none',
  flexDirection: 'row',
  '& .MuiTypography-root': {
    color: theme.palette.gray.A500,
  },
  [`&.${SELECTABLE_CARD_STACK_ACTIVE_CLASS_NAME}`]: {
    ...selectableCardStackActive({ theme }),
    '& .MuiTypography-root': {
      color: theme.palette.primary.main,
    },
  },
});

const verticalScrollStack = () => ({
  alignSelf: 'stretch',
  width: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
});

const primaryVerticalDividersStack = ({ theme }) => ({
  columnGap: theme.spacing(1),
  marginLeft: `calc(-${theme.spacing(1)} - 1px)`,
  '& > *': {
    paddingLeft: theme.spacing(1),
    borderLeft: `1px solid ${theme.palette.primary.main}`,
  },
});

const MuiStack = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${PRIMARY_STACK_CLASS_NAME}`]: primaryStack({ theme }),
      [`&.${ICON_STACK_CLASS_NAME}`]: iconStack({ theme }),
      [`&.${SUCCESS_STACK_CLASS_NAME}`]: successStack({ theme }),
      [`&.${WARNING_STACK_CLASS_NAME}`]: warningStack({ theme }),
      [`&.${DASHED_WARNING_STACK_CLASS_NAME}`]: dashedWarningStack({ theme }),
      [`&.${DASHED_GRAY_STACK_CLASS_NAME}`]: dashedGrayStack({ theme }),
      [`&.${SECONDARY_STACK_CLASS_NAME}`]: secondaryStack({ theme }),
      [`&.${INFORMATION_STACK_CLASS_NAME}`]: informationStack({ theme }),
      [`&.${UPLOAD_DOCUMENT_STACK_CLASS_NAME}`]: uploadDocumentStack({ theme }),
      [`&.${DASHED_OUTLINE_STACK_CLASS_NAME}`]: dashedOutlineStack({ theme }),
      [`&.${HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME}`]: highlightedUploadDocumentStack({ theme, borderColor: theme.palette.primary.main }),
      [`&.${COLORED_BORDERED_STACK_CLASS_NAME}`]: coloredBorderedStack({ theme }),
      [`&.${PRIMARY_CONFIRMATION_ICON_STACK_CLASS_NAME}`]: confirmationIconStack({ theme }),
      [`&.${SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME}`]: confirmationIconStack({ theme }),
      [`&.${PENDING_STACK_CLASS_NAME}`]: pendingStack({ theme }),
      [`&.${BORDERED_BACKGROUND_STACK_CLASS_NAME}`]: borderedBackgroundStack({ theme }),
      [`&.${SELECTABLE_CARD_STACK_CLASS_NAME}`]: selectableCardStack({ theme }),
      [`&.${SELECTABLE_CARD_LINK_STACK_CLASS_NAME}`]: selectableCardLinkStack({ theme }),
      [`&.${VERTICAL_SCROLL_STACK_CLASS_NAME}`]: verticalScrollStack(),
      [`&.${PRIMARY_VERTICAL_DIVIDERS_STACK_CLASS_NAME}`]: primaryVerticalDividersStack({ theme }),
    }),
  },
};

export default MuiStack;
